import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SuccessMessage from '../../Molecules/SuccessMessage/SuccessMessage';
import ForgotPasswordForm from '../../Organisms/CommonForm/CommonForm';
import './ForgotPasswordTemplate.less';
import { getDecodedAccessToken } from '../../../utils/functions';
/**
 * @template ForgotPasswordTemplate.tsx
 * @description ForgotPasswordTemplate
 * @return { Template }
 */
function ForgotPasswordTemplate() {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [tokenInfo, setTokenInfo] = useState('');
  const [searchParams] = useSearchParams();
  const successMessage = () => {
    setShowSuccessMessage(true);
  };
  useEffect(() => {
    if (searchParams.get('token')) {
      setTokenInfo(getDecodedAccessToken(searchParams.get('token')!).email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Layout className="tp-forgot-password__layout">
      <div className="org-navbar-logo" />
      <div className="tp-forgot-password__container">
        {!showSuccessMessage ? (
          <ForgotPasswordForm
            isRegister={true}
            forgotPassword={true}
            successMessage={successMessage}
          />
        ) : (
          <SuccessMessage userName={tokenInfo} />
        )}
      </div>
    </Layout>
  );
}
export default ForgotPasswordTemplate;
